import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { Analytics } from "@vercel/analytics/react";
import "./App.css";
import Footer from "./components/Footer";
import Home from "./components/Home";
import MainNav from "./components/MainNav";
import About from "./components/pages/About";
import Contact from "./components/pages/Contact";
import Event from "./components/pages/Event";
import Ranking from "./components/pages/Ranking";
import FeaturedUpdate from "./components/pages/FeaturedUpdate";
import FeatureupdatePost from "./components/pages/FeatureupdatePost";
import RenderNews from "./components/RenderNews";
import ProgressBar from "./components/ProgressBar";
import JoinWBCAMTI from "./components/pages/JoinWBCAMTI";
import NotFound from "./components/pages/NotFound";
// import NewUpload from "./components/pages/NewUpload";
import Login from "./components/Login";
import Profile from "./components/profiles/StateProfile";
import Circular from './components/pages/Circular';
import States from './components/pages/States';
import LatestUpdatePost from './components/LatestUpdatePost';
import Connect from './components/pages/Connect';
import Playerprofile from './components/pages/Playerprofile';
import Athlete from './components/pages/Athelet';
import LoginPlayer from './components/LoginPlayer';
import ProfileDashboard from './components/profiles/playerDashboard';
import Profiles from './components/pages/Profiles';
import WbcLanding from './components/pages/wbc _landing_2026/WbcLanding';

const WBC_LANDING_PATH = '/wbc-championship-2026';

function AppRoutes() {
  const location = useLocation();
  const landingOnly = location.pathname === WBC_LANDING_PATH;

  return (
    <div className={landingOnly ? '' : 'bgr bg-[#E9EAEC]'}>
      {!landingOnly && <ProgressBar />}
      {!landingOnly && <MainNav />}
      <Routes>
          <Route path="/" index element={<Home />} />
          <Route path="fu_post" element={<FeatureupdatePost />} />
          {/* <Route path="latest" element={<LatestUpdate />} /> */}
          <Route path="ltpost" element={<LatestUpdatePost />} />
          {/* <Route path="n_upload" element={<NewUpload />} /> */}
          <Route path="about" element={<About />} />
          <Route path="featureupdate/:title" element={<RenderNews prop="featured" />} />
          <Route path="connect" element={<Connect />} />
          <Route path="events" element={<Event />} />
          <Route path="events/:title" element={<RenderNews prop="events" />} />
          <Route path="news" element={<FeaturedUpdate />} />
          <Route path="rankings" element={<Ranking />} />
          <Route path="athlete" element={<Athlete />} />
          <Route path="*" element={<NotFound />} />
          <Route path="jnwbcamti" element={<JoinWBCAMTI />} />
          <Route path="contact" element={<Contact />} />
          <Route path="circulars" element={<Circular />} />
          <Route path="players/profile" element={<Playerprofile />} />
          <Route path="states" element={<States />} />
          {/* <Route path="profiledash" element={isAuthenticated ? <ProfileDashboard />: <LoginPlayer/>} /> */}
          <Route path="login" element={<Login />} />
          <Route path="dashboard" element={ <Profiles /> } />
          <Route path="wbc-championship-2026" element={<WbcLanding />} />
        </Routes>
      {!landingOnly && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppRoutes />
      <Analytics />
    </Router>
  );
}

export default App;
